// Each URL has fixed colors: browsers can cache a rasterized SVG favicon even
// after the system appearance changes. Keep the unthemed URL as the status key.
// Media hints select the right assets before hydration (and without JavaScript).
export const faviconLinks = ["light", "dark"].flatMap((scheme) => [
  {
    rel: "alternate icon",
    type: "image/png",
    href: `/favicon-${scheme}.png`,
    media: `(prefers-color-scheme: ${scheme})`,
    "data-favicon-href": "/favicon.svg",
  },
  {
    rel: "icon",
    type: "image/svg+xml",
    href: `/favicon-${scheme}.svg`,
    media: `(prefers-color-scheme: ${scheme})`,
    "data-favicon-href": "/favicon.svg",
  },
])

export function updateSystemFavicon() {
  // Deliberately independent of ThemeProvider and the saved in-app theme.
  const scheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
  // Update every candidate so switching media cannot resurrect an old status.
  // Changing the URLs also forces Edge to refresh its rasterized favicon.
  for (const icon of document.querySelectorAll<HTMLLinkElement>("link[data-favicon-href]")) {
    const href = icon.getAttribute("data-favicon-href")
    if (!href) continue
    const extension = icon.type === "image/png" ? "png" : "svg"
    icon.setAttribute("href", href.replace(/\.svg$/, `-${scheme}.${extension}`))
  }
}

export function setFaviconHref(href: string) {
  for (const icon of document.querySelectorAll("link[data-favicon-href]")) {
    icon.setAttribute("data-favicon-href", href)
  }
  updateSystemFavicon()
}
